{
    "TelephonenosLabel": "Numéro(s) de téléphone :",
    "AcdagentsLabel": "Agent(s) ACD :",
    "LocationLabel": "Emplacement vers\/depuis :",
    "LocationOptionAny": "[Tout appel vers\/depuis ces lieux]",
    "LocationOptionFrom": "Appels uniquement à partir de ces endroits",
    "LocationOptionTo": "Appels uniquement vers ces endroits",
    "LocationalFiltering_SectionHeader": "Filtrage géographique",
    "LocationalFiltering_AnyPlaceholder": "[N'importe lequel]",
    "LocationalFiltering_DevicesLabel": "Dispositif(s) :",
    "NAME": "LocationalFiltering",
    "TelephonenosLabelDNIS": "Numéro(s) de téléphone \/ Numéro(s) DNIS :",
    "TelephonenoDescriptionsLabel": "Numéro de téléphone Description(s) :",
    "AcdagentsLabel_MST": "Agent(s) :"
}